'use client'

import { ICategory } from '@/app/[locale]/_types'
import { Button } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { LuPlus } from 'react-icons/lu'

const Desktop = ({
  data,
  hasNextPage,
  count,
  fetchNextPage,
  isFetchingNextPage,
}: {
  hasFilter?: boolean
  count?: number | string
  hasNextPage?: boolean
  fetchNextPage?: () => void
  isFetchingNextPage?: boolean
  data: ICategory[]
}) => {
  const t = useTranslations()

  if (!hasNextPage || data?.length >= Number(count)) {
    return null
  }
  return (
    <Button
      h={14}
      px={4}
      gap={2}
      size='lg'
      rounded={16}
      variant='outline'
      borderColor='#00000014'
      color='text.muted'
      onClick={() => fetchNextPage?.()}
      disabled={isFetchingNextPage}
      loading={isFetchingNextPage}
    >
      <LuPlus size='1rem' />
      {t('more')}
    </Button>
  )
}

export default Desktop
